// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Table from "../components/Table/Table";
// import SunburstGraph from "../components/Shipment Tracker/SunburstGraph";
// import StackBarGraph from "../components/Shipment Tracker/StackBarGraph";
// import QualityLossGraph from "../components/Shipment Tracker/QualityLossGraph";
// import ShippedModulesGraph from "../components/Shipment Tracker/ShippedModulesGraph";
// import TrendLineGraph from "../components/Shipment Tracker/TrendLineGraph";
// import BarChartGraph from "../components/Shipment Tracker/BarChartGraph";
// import { Tabs, Tab, Card, CardContent, Typography, Grid } from "@mui/material";

// const Dashboard = () => {
//   const [data, setData] = useState([]);
//   const [graphData, setGraphData] = useState({});
//   const [tabIndex, setTabIndex] = useState(0);

//   const headers = [
//     { dbParam: "supplier_name", displayName: "Supplier Name" },
//     { dbParam: "module_wattage", displayName: "Module Wattage" },
//     { dbParam: "total_planned_modules", displayName: "Total Planned Modules" },
//     { dbParam: "module_count_pdi", displayName: "Module Count (PDI)" },
//     { dbParam: "module_count_pdi_percentage", displayName: "Module Count (PDI%)" },
//     { dbParam: "no_of_modules_shipped", displayName: "No. of Modules Shipped" },
//     { dbParam: "no_of_modules_shipped_percentage", displayName: "% of Modules Shipped" },
//     { dbParam: "quality_loss", displayName: "Quality Loss" },
//     { dbParam: "produced_capacity", displayName: "Produced Capacity (MWp)" },
//     { dbParam: "produced_modules", displayName: "Produced Modules" },
//   ];

//   useEffect(() => {
//     const fetchData = async () => {
//       const projectId = localStorage.getItem("selectedProject");
//       if (!projectId) {
//         console.error("No projectId in localStorage");
//         return;
//       }

//       try {
//         // Fetch shipment data
//         sessionStorage.removeItem("shipmentData");
//         const shipmentResponse = await axios.post(
//           "https://redoms-backend-dev.m-devsecops.com/shipment_tracker_refresh",
//           { projectId }
//         );
//         const shipmentData = shipmentResponse.data.shipment_data || [];

//         // Process shipment data to replace "N/A" in quality_loss with 0
//         const processedShipmentData = shipmentData.map(item => ({
//           ...item,
//           quality_loss: item.quality_loss === "N/A" ? 0 : item.quality_loss,
//         }));

//         sessionStorage.setItem("shipmentData", JSON.stringify({ ...shipmentResponse.data, shipment_data: processedShipmentData }));
//         setData(processedShipmentData);
//       } catch (error) {
//         console.error("Error fetching shipment data:", error.message);
//       }

//       try {
//         // Fetch graph data
//         const graphResponse = await axios.get("https://redoms-backend-dev.m-devsecops.com/get_graph_data", {
//           params: { projectId },
//         });
//         setGraphData(graphResponse.data.data || {});
//       } catch (error) {
//         console.error("Error fetching graph data:", error.message);
//       }
//     };

//     fetchData();
//   }, []);

//   // Compute card values
//   const totalPlannedModules = data.length ? data.reduce((sum, item) => sum + (item["total_planned_modules"] || 0), 0) : 0;
//   const producedModulesPDI = data.length ? data.reduce((sum, item) => sum + (item["module_count_pdi"] || 0), 0) : 0;
//   const shippedModules = data.length ? data.reduce((sum, item) => sum + (item["no_of_modules_shipped"] || 0), 0) : 0;
//   const modulesToBeShipped = totalPlannedModules - shippedModules;

//   const allottedCapacity = data.length
//     ? parseFloat(
//         data.reduce((sum, item) => {
//           const modules = parseFloat(item["total_planned_modules"] || 0);
//           const wattage = parseFloat(item["module_wattage"] || 0);
//           return sum + (modules * wattage) / 1000000;
//         }, 0).toFixed(3)
//       )
//     : 0;

//   const qualityLoss = data.length
//     ? (() => {
//         const weightedSum = data.reduce((sum, item) => {
//           const qualityLossValue = typeof item["quality_loss"] === "string" && item["quality_loss"] !== "N/A"
//             ? parseFloat(item["quality_loss"]) || 0
//             : item["quality_loss"] || 0; // Handle numeric or processed 0
//           const moduleWattage = parseFloat(item["module_wattage"] || 0);
//           return sum + (qualityLossValue * moduleWattage);
//         }, 0);
//         const totalWattage = data.reduce((sum, item) => sum + parseFloat(item["module_wattage"] || 0), 0);
//         return totalWattage > 0 ? parseFloat((weightedSum / totalWattage).toFixed(2)) : 0;
//       })()
//     : 0;

//   // Aggregate producedModules and cumulativeMWp from graphData
//   let totalProducedModules = 0;
//   let totalProducedCapacity = 0;
//   const wattageWiseData = {};

//   if (Object.keys(graphData).length) {
//     Object.values(graphData).forEach((dateData) => {
//       dateData.forEach((item) => {
//         totalProducedModules += item.producedModules || 0;
//         totalProducedCapacity += item.cumulativeMWp || 0;

//         // Aggregate wattage-wise data
//         const wattage = item.wattage;
//         if (!wattageWiseData[wattage]) {
//           wattageWiseData[wattage] = {
//             producedModules: 0,
//             producedCapacity: 0,
//           };
//         }
//         wattageWiseData[wattage].producedModules += item.producedModules || 0;
//         wattageWiseData[wattage].producedCapacity += item.cumulativeMWp || 0;
//       });
//     });
//   }

//   // Merge wattage-wise data with shipment data for the table
//   const tableData = data.map((item) => ({
//     ...item,
//     produced_capacity: wattageWiseData[item.module_wattage]?.producedCapacity.toFixed(3) || 0,
//     produced_modules: wattageWiseData[item.module_wattage]?.producedModules || 0,
//   }));

//   const cardsData = [
//     { title: "Allotted Capacity (Incl. Spares)", value: allottedCapacity !== 0 ? `${allottedCapacity} MW` : "N/A" },
//     { title: "Produced Capacity", value: totalProducedCapacity !== 0 ? `${totalProducedCapacity.toFixed(3)} MWp` : "N/A" },
//     { title: "Total No. of Modules", value: totalPlannedModules || "N/A" },
//     { title: "Produced Modules", value: totalProducedModules || "N/A" },
//     { title: "PDI Approved Modules", value: producedModulesPDI || "N/A" },
//     { title: "Shipped Modules", value: shippedModules || "N/A" },
//     { title: "Quality Loss", value: qualityLoss !== 0 ? `${qualityLoss}%` : "0%" }, // Ensure 0% for display
//     { title: "Modules to be Shipped", value: modulesToBeShipped || "N/A" },
//   ];

//   const handleTabChange = (event, newValue) => {
//     setTabIndex(newValue);
//   };

//   return (
//     <div className="p-4 space-y-8 bg-gray-100">
//       {/* Cards Section */}
//       <Grid container spacing={2} justifyContent="center">
//         {cardsData.map((card, index) => (
//           <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
//             <Card
//               sx={{
//                 minHeight: 120,
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 transition: "all 0.3s ease-in-out",
//                 backgroundColor: "#fff",
//                 boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
//               }}
//             >
//               <CardContent
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   textAlign: "center",
//                   padding: 2,
//                   flexGrow: 1,
//                 }}
//               >
//                 <Typography variant="h6" sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }}>
//                   {card.title}
//                 </Typography>
//                 <Typography
//                   variant="h4"
//                   color="primary"
//                   sx={{ fontSize: { xs: "1.5rem", sm: "2rem" }, fontWeight: "bold" }}
//                 >
//                   {card.value}
//                 </Typography>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Tabs for Graphs */}
//       <Tabs value={tabIndex} onChange={handleTabChange} variant="fullWidth">
//         <Tab label="Module Status" />
//         <Tab label="Module Status (Detailed View)" />
//         <Tab label="Quality Loss" />
//         <Tab label="Current Binning" />
//         <Tab label="Production Trend A" />
//         <Tab label="Production Trend B" />
//       </Tabs>

//       {/* Graph Components */}
//       <div className="p-4 bg-white rounded-lg shadow-md">
//         {tabIndex === 0 && <StackBarGraph data={data} />}
//         {tabIndex === 1 && <SunburstGraph data={data} />}
//         {tabIndex === 2 && <QualityLossGraph data={data} />}
//         {tabIndex === 3 && <ShippedModulesGraph data={data} />}
//         {tabIndex === 4 && <TrendLineGraph data={graphData} />}
//         {tabIndex === 5 && <BarChartGraph data={graphData} />}
//       </div>

//       {/* Table */}
//       <div className="p-4 bg-white rounded-lg shadow-md">
//         <Table tableHeaders={headers} tableData={tableData} />
//       </div>
//     </div>
//   );
// };

// export default Dashboard;



import React, { useState, useEffect } from "react";
import axios from "axios";
import Table from "../components/Table/Table";
import SunburstGraph from "../components/Shipment Tracker/SunburstGraph";
import StackBarGraph from "../components/Shipment Tracker/StackBarGraph";
import QualityLossGraph from "../components/Shipment Tracker/QualityLossGraph";
import ShippedModulesGraph from "../components/Shipment Tracker/ShippedModulesGraph";
import TrendLineGraph from "../components/Shipment Tracker/TrendLineGraph";
import BarChartGraph from "../components/Shipment Tracker/BarChartGraph";
import { Tabs, Tab, Card, CardContent, Typography, Grid } from "@mui/material";
import loaderGif from "../assets/graphLoader.gif"; // Import the loader GIF

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [graphData, setGraphData] = useState({});
  const [tabIndex, setTabIndex] = useState(0);
  const [loading, setLoading] = useState(true); // Add loading state
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const headers = [
    { dbParam: "supplier_name", displayName: "Supplier Name" },
    { dbParam: "module_wattage", displayName: "Module Wattage" },
    { dbParam: "total_planned_modules", displayName: "Total Planned Modules" },
    { dbParam: "module_count_pdi", displayName: "Module Count (PDI)" },
    { dbParam: "module_count_pdi_percentage", displayName: "Module Count (PDI%)" },
    { dbParam: "no_of_modules_shipped", displayName: "No. of Modules Shipped" },
    { dbParam: "no_of_modules_shipped_percentage", displayName: "% of Modules Shipped" },
    { dbParam: "quality_loss", displayName: "Quality Loss" },
    { dbParam: "produced_capacity", displayName: "Produced Capacity (MWp)" },
    { dbParam: "produced_modules", displayName: "Produced Modules" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const projectId = localStorage.getItem("selectedProject");
      if (!projectId) {
        console.error("No projectId in localStorage");
        setLoading(false); // Stop loading if no projectId
        return;
      }

      try {
        // Fetch shipment data
        sessionStorage.removeItem("shipmentData");
        const shipmentResponse = await axios.post(
          `${baseURL}shipment_tracker_refresh`,
          { projectId }
        );
        const shipmentData = shipmentResponse.data.shipment_data || [];

        // Process shipment data to replace "N/A" in quality_loss with 0
        const processedShipmentData = shipmentData.map(item => ({
          ...item,
          quality_loss: item.quality_loss === "N/A" ? 0 : item.quality_loss,
        }));

        sessionStorage.setItem("shipmentData", JSON.stringify({ ...shipmentResponse.data, shipment_data: processedShipmentData }));
        setData(processedShipmentData);
      } catch (error) {
        console.error("Error fetching shipment data:", error.message);
      } finally {
        setLoading(false); // Stop loading after shipment data fetch
      }

      try {
        // Fetch graph data
        const graphResponse = await axios.get(`${baseURL}get_graph_data`, {
          params: { projectId },
        });
        setGraphData(graphResponse.data.data || {});
      } catch (error) {
        console.error("Error fetching graph data:", error.message);
      }
    };

    fetchData();
  }, []);

  // Compute card values
  const totalPlannedModules = data.length ? data.reduce((sum, item) => sum + (item["total_planned_modules"] || 0), 0) : 0;
  const producedModulesPDI = data.length ? data.reduce((sum, item) => sum + (item["module_count_pdi"] || 0), 0) : 0;
  const shippedModules = data.length ? data.reduce((sum, item) => sum + (item["no_of_modules_shipped"] || 0), 0) : 0;
  const modulesToBeShipped = totalPlannedModules - shippedModules;

  const allottedCapacity = data.length
    ? parseFloat(
        data.reduce((sum, item) => {
          const modules = parseFloat(item["total_planned_modules"] || 0);
          const wattage = parseFloat(item["module_wattage"] || 0);
          return sum + (modules * wattage) / 1000000;
        }, 0).toFixed(3)
      )
    : 0;

  const qualityLoss = data.length
    ? (() => {
        // Count non-zero quality_loss values and track the single non-zero value
        const nonZeroValues = data
          .map(item => {
            const qualityLossValue = typeof item["quality_loss"] === "string" && item["quality_loss"] !== "N/A"
              ? parseFloat(item["quality_loss"]) || 0
              : item["quality_loss"] || 0;
            return qualityLossValue;
          })
          .filter(value => value !== 0);

        // If exactly one non-zero value exists, return it directly
        if (nonZeroValues.length === 1) {
          return parseFloat(nonZeroValues[0].toFixed(2));
        }

        // If multiple non-zero values or none, compute weighted average
        const weightedSum = data.reduce((sum, item) => {
          const qualityLossValue = typeof item["quality_loss"] === "string" && item["quality_loss"] !== "N/A"
            ? parseFloat(item["quality_loss"]) || 0
            : item["quality_loss"] || 0;
          const moduleWattage = parseFloat(item["module_wattage"] || 0);
          return sum + (qualityLossValue * moduleWattage);
        }, 0);

        const totalWattage = data.reduce((sum, item) => sum + parseFloat(item["module_wattage"] || 0), 0);
        return totalWattage > 0 ? parseFloat(((weightedSum / totalWattage)).toFixed(2)) : 0;
      })()
    : 0;

  // Aggregate producedModules and cumulativeMWp from graphData
  let totalProducedModules = 0;
  let totalProducedCapacity = 0;
  const wattageWiseData = {};

  if (Object.keys(graphData).length) {
    // Step 1: Find the latest date for cumulativeMWp
    const latestDate = Object.keys(graphData).sort().pop();

    // Step 2: Initialize wattage-wise totals
    Object.keys(graphData).forEach(date => {
      graphData[date].forEach(item => {
        const wattage = item.wattage;
        if (!wattageWiseData[wattage]) {
          wattageWiseData[wattage] = {
            producedModules: 0,
            producedCapacity: 0,
          };
        }
        // Add daily produced modules
        wattageWiseData[wattage].producedModules += item.producedModules || 0;

        // Only update cumulativeMWp if this is the latest date
        if (date === latestDate) {
          wattageWiseData[wattage].producedCapacity = item.cumulativeMWp || 0;
          totalProducedCapacity += item.cumulativeMWp || 0;
        }
      });
    });

    // Step 3: Total produced modules across all time
    totalProducedModules = Object.values(wattageWiseData).reduce(
      (sum, item) => sum + item.producedModules,
      0
    );
  }
  // Merge wattage-wise data with shipment data for the table
  const tableData = data.map((item) => ({
    ...item,    
    produced_capacity: wattageWiseData[item.module_wattage]?.producedCapacity.toFixed(3) || 0,
    produced_modules: wattageWiseData[item.module_wattage]?.producedModules || 0,
  }));

  const cardsData = [
    { title: "Allotted Capacity (Incl. Spares)", value: allottedCapacity !== 0 ? `${allottedCapacity} MW` : "N/A" },
    { title: "Produced Capacity", value: totalProducedCapacity !== 0 ? `${totalProducedCapacity.toFixed(3)} MWp` : "N/A" },
    { title: "Total No. of Modules", value: totalPlannedModules || "N/A" },
    { title: "Produced Modules", value: totalProducedModules || "N/A" },
    { title: "PDI Approved Modules", value: producedModulesPDI || "N/A" },
    { title: "Shipped Modules", value: shippedModules || "N/A" },
    { title: "Quality Loss", value: qualityLoss !== 0 ? `${qualityLoss}%` : "0%" },
    { title: "Modules to be Shipped", value: modulesToBeShipped || "N/A" },
  ];

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <div className="p-4 space-y-8 bg-gray-100">
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <img src={loaderGif} alt="Loading..." className="w-28 h-28" />
        </div>
      ) : (
        <>
          {/* Cards Section */}
          <Grid container spacing={2} justifyContent="center">
            {cardsData.map((card, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <Card
                  sx={{
                    minHeight: 120,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    transition: "all 0.3s ease-in-out",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      padding: 2,
                      flexGrow: 1,
                    }}
                  >
                    <Typography variant="h6" sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }}>
                      {card.title}
                    </Typography>
                    <Typography
                      variant="h4"
                      color="primary"
                      sx={{ fontSize: { xs: "1.5rem", sm: "2rem" }, fontWeight: "bold" }}
                    >
                      {card.value}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Tabs for Graphs */}
          <Tabs value={tabIndex} onChange={handleTabChange} variant="fullWidth">
            <Tab label="Module Status" />
            <Tab label="Module Status (Detailed View)" />
            <Tab label="Quality Loss" />
            <Tab label="Current Binning" />
            <Tab label="Cummulative Wattage" />
            <Tab label="Daily Wattage Trend" />
          </Tabs>

          {/* Graph Components */}
          <div className="p-4 bg-white rounded-lg shadow-md">
            {tabIndex === 0 && <StackBarGraph data={tableData} />}
            {tabIndex === 1 && <SunburstGraph data={data} />}
            {tabIndex === 2 && <QualityLossGraph data={data} />}
            {tabIndex === 3 && <ShippedModulesGraph data={data} />}
            {tabIndex === 4 && <TrendLineGraph data={graphData} />}
            {tabIndex === 5 && <BarChartGraph data={graphData} />}
          </div>

          {/* Table */}
          <div className="p-4 bg-white rounded-lg shadow-md">
            <Table tableHeaders={headers} tableData={tableData} />
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;